import { trans } from '~/utilities';
import CrossIcon from '~/../symbols/cross.svg';

export default class FileUpload {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.input = this.DOM.el.querySelector('.custom-file-input');
        this.DOM.label = this.DOM.el.querySelector('.custom-file-label');
        this.DOM.list = null;

        if (!this.DOM.input || !this.DOM.label) {
            return;
        }

        this.placeholder = this.DOM.label.textContent;
        this.files = [];

        this.initEvents();
    }

    initEvents() {
        this.DOM.input.addEventListener('change', () => {
            this.files = Array.from(this.DOM.input.files);
            this.render();
        });
    }

    remove(index) {
        this.files.splice(index, 1);

        const dataTransfer = new DataTransfer();
        this.files.forEach((file) => dataTransfer.items.add(file));
        this.DOM.input.files = dataTransfer.files;

        this.render();
    }

    render() {
        this.renderLabel();
        this.renderList();
    }

    renderLabel() {
        if (this.files.length === 0) {
            this.DOM.label.textContent = this.placeholder;
            return;
        }

        if (this.files.length === 1) {
            this.DOM.label.textContent = this.files[0].name;
            return;
        }

        this.DOM.label.textContent = trans('app.form.attachment.selected_files', {
            count: this.files.length,
        }, `${this.files.length} bestanden geselecteerd`);
    }

    renderList() {
        if (this.files.length === 0) {
            if (this.DOM.list) {
                this.DOM.list.remove();
                this.DOM.list = null;
            }

            return;
        }

        if (!this.DOM.list) {
            this.DOM.list = document.createElement('ul');
            this.DOM.list.className = 'list list--attachment';
            this.DOM.list.setAttribute('aria-live', 'polite');
            this.DOM.el.insertAdjacentElement('afterend', this.DOM.list);
        }

        this.DOM.list.textContent = '';

        this.files.forEach((file, index) => {
            this.DOM.list.appendChild(this.createItem(file, index));
        });
    }

    createItem(file, index) {
        const item = document.createElement('li');
        item.className = 'list__item';

        const label = document.createElement('span');
        label.className = 'list__label text-truncate';
        label.textContent = file.name;

        const size = document.createElement('span');
        size.className = 'list__size';
        size.textContent = this.formatSize(file.size);

        item.appendChild(label);
        item.appendChild(size);
        item.appendChild(this.createRemoveButton(file, index));

        return item;
    }

    createRemoveButton(file, index) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'list__action btn btn-none d-flex align-items-center';
        button.setAttribute('aria-label', trans('app.form.attachment.remove', {
            file: file.name,
        }, `${file.name} verwijderen`));

        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('class', 'icon icon--12');

        const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
        use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', CrossIcon.url);

        icon.appendChild(use);
        button.appendChild(icon);

        button.addEventListener('click', () => this.remove(index));

        return button;
    }

    formatSize(bytes) {
        const units = ['B', 'kB', 'MB', 'GB'];
        let size = bytes;
        let unit = 0;

        while (size >= 1000 && unit < units.length - 1) {
            size = size / 1000;
            unit++;
        }

        const decimals = unit === 0 || size >= 100 ? 0 : 1;

        return `${size.toFixed(decimals).replace('.', ',')} ${units[unit]}`;
    }
}

Array.from(document.querySelectorAll('.custom-file')).forEach((el) => {
    new FileUpload(el);
});
